import { Card, Typography, Chip, Stack } from "@mui/material";
import { Box } from "@mui/system";
import {
  typography,
  spacing,
  colors,
  shadows,
} from "../../../../../../../../../assets/styles/tokens";

type StatusColor = "success" | "warning" | "error";

interface BudgetSearchItemsCardProps {
  title: string;
  brandId: string;
  value: string;
  budget: string;
  budgetPercentage: string;
  budgetColor: StatusColor;
  rr: string;
  rrPercentage: string;
  rrColor:StatusColor;
}
 
const buildShadow = (shadowToken: any) =>
  shadowToken.$value
    .map(
      (s: any) => `${s.offsetX} ${s.offsetY} ${s.blur} ${s.spread} ${s.color}`,
    )
    .join(", ");

export function BudgetSearchItemsCard({
  title,
  brandId,
  value,
  budget,
  budgetPercentage,
  budgetColor,
  rr,
  rrPercentage,
  rrColor
}: BudgetSearchItemsCardProps) {
  return (
    <>
      <Card
        sx={{
          p: 1,
          borderRadius: spacing.Radius.lg.$value,
          boxShadow: buildShadow(shadows.Shadows.sm),
          border: "1px solid" + colors.GrayLightMode[200].$value,
          mb: spacing.Spacing.xs.$value + "!important",
          "&:not(:first-of-type)": {
            mt: spacing.Spacing.lg.$value,
          },
        }}
      >
        {/* Top Row */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="body1"
            sx={{
              color: colors.GrayLightMode[700].$value,
              fontWeight: typography.Font_weight.Medium.$value,
              fontSize: typography.Size.Text.xs.$value,
              m: 0,
            }}
          >
            {title} ({brandId})
          </Typography>
        </Stack>

        <Stack
          sx={{ my: spacing.Spacing.xs.$value }}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="body1"
            sx={{ fontSize: typography.Size.Text.sm.$value }}
          >
            <Box
              component="span"
              sx={{
                fontSize: typography.Size.Text.xl.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                mr: spacing.Spacing.xs.$value,
              }}
            >
              {value}
            </Box>
            QFTD’s of 
            <Box
              component="span"
              sx={{ fontWeight: typography.Font_weight.Medium.$value, mx:1 }}
            >
               {budget} 
            </Box>
            Budgeted
          </Typography>
          <Chip
            label={budgetPercentage}
            size="medium"
            sx={{
              borderRadius: spacing.Radius.xs.$value,
              bgcolor:
                budgetColor === "success"
                  ? colors.Success[50].$value
                  : budgetColor === "warning"
                    ? colors.Warning[50].$value
                    : colors.Error[50].$value,

              color:
                budgetColor === "success"
                  ? colors.Success[600].$value
                  : budgetColor === "warning"
                    ? colors.Warning[600].$value
                    : colors.Error[600].$value,

              fontWeight: typography.Font_weight.Semibold.$value,
              fontSize: typography.Size.Text.sm.$value,
            }}
          />
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box display={"flex"} alignItems="center">
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
              }}
            >
              Predicated RR
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: colors.GrayLightMode[900].$value,
                fontWeight: typography.Font_weight.Bold.$value,
                mx: 1,
              }}
            >
              {rr}
            </Typography>
            <Chip
              label={rrPercentage}
              size="small"
              sx={{
                borderRadius: spacing.Radius.xs.$value,
                bgcolor:
                  rrColor === "success"
                    ? colors.Success[50].$value
                    : rrColor === "warning"
                      ? colors.Warning[50].$value
                      : colors.Error[50].$value,

                color:
                  rrColor === "success"
                    ? colors.Success[600].$value
                    : rrColor === "warning"
                      ? colors.Warning[600].$value
                      : colors.Error[600].$value,

                fontWeight: typography.Font_weight.Semibold.$value,
              }}
            />
          </Box>
        </Stack>
      </Card>
    </>
  );
}

export default BudgetSearchItemsCard;
